exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-row[data-v-3a08b45d]{padding:20px;margin:0}p[data-v-3a08b45d]{margin:20 0;color:#000;font-size:16px}", "", {"version":3,"sources":["/home/www/deploy/school/src/views/purchase_apply/staff.vue"],"names":[],"mappings":"AACA,yBACE,aAAc,AACd,QAAU,CACX,AACD,mBACE,YAAa,AACb,WAAe,AACf,cAAgB,CACjB","file":"staff.vue","sourcesContent":["\n.el-row[data-v-3a08b45d] {\n  padding: 20px;\n  margin: 0;\n}\np[data-v-3a08b45d] {\n  margin: 20 0;\n  color: #000000;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a08b45d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/purchase_apply/staff.vue
// module id = liMC
// module chunks = 70